import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, IFailureAction } from "interfaces/export-duck";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "FETCH_INVOICE_FILE_" }
);

export interface FetchInvoiceFilesState
  extends Pick<IState, "error" | "loading"> {
  data: string | null;
}

interface ISuccessFetchInvoiceFilesAction {
  data: string;
}

const INITIAL_STATE: FetchInvoiceFilesState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: FetchInvoiceFilesState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: FetchInvoiceFilesState,
  action: ISuccessFetchInvoiceFilesAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: FetchInvoiceFilesState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const fetchInvoiceFile = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchInvoiceFilesTypes = Types;
export const FetchInvoiceFileActions = Creators;
